import React, {useEffect, useState} from 'react';
import {Link, useLocation, useNavigate, useOutletContext, useParams, useSearchParams} from 'react-router-dom';
import TitleMain from "../../../components/Title/TitleMain";
import {useModal} from "../../../contexts/ModalContext";
import {useUser} from "../../../contexts/UserContext";
import AxiosConfig from "../../../services/AxiosConfig";
import {generateBreadcrumbSegmentsAdmin} from "../../../services/BreadcrumbService";
import {useBreadcrumb} from "../../../contexts/BreadcrumbContext";
import styles from "../Admin.module.css";
import CrmTypeTable from "../../../components/Admin/Crm/CrmTypeTable";

function AdminCrmTypesPage() {
    const {user} = useUser();
    const {showModal, hideModal} = useModal();
    const [myApiData, setMyApiData] = useState([]);
    const { updateDynamicBreadcrumb } = useBreadcrumb();
    const [searchParams] = useSearchParams();
    const mode = searchParams.get('mode') || 'consultation';
    const [absences, setAbsences] = useState([]);
    const navigate = useNavigate();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);

    const handleSuccess = (children = "Note enregistrée avec succès") => {
        showModal('success', {children: children, timeout: 1500});
    };
    const handleError = (children = "Une erreur est survenue") => {
        showModal('error', {children: children, timeout: 1500});
    };


    useEffect(() => {
        (async () => {
            try {
                const response = await AxiosConfig.get('/admin/crm/types');
                setMyApiData(response.data.myCrmTypes);
            } catch (error) {
                console.error('error', error);
            }
        })();
    }, [user, mode, location.search]);

    useEffect(() => {
        updateDynamicBreadcrumb(generateBreadcrumbSegmentsAdmin({ }));
    }, []);

    return (
        <div className="content">
            <TitleMain text="CRM types"/>

            <div className={styles.navLink}>
                {/*
                <Link to="/admin/crm/types?mode=creation">
                    <AjouterIcone />
                    Créer un type de CRM
                </Link>
                */}
            </div>

            <CrmTypeTable crmtypes={myApiData} />

            {/* <pre>{JSON.stringify(myApiData, null, 2)}</pre> */}
        </div>
    )
}

export default AdminCrmTypesPage;
